export enum APP_EVENTS {
  // LOGIN
  LOGIN_EVENT = 'login',
  // CHANGE CHILD
  SWITCH_NAME = 'switch_name',
  // DASHOARD
  DASHBOARD_VIDEO_LESSON_CLICKED = 'dashboard-video-lesson-clicked',
  DASHBOARD_VIDEO_LESSON_VIDEO_CLICKED = 'dashboard-video-lesson-video-clicked',
  DASHBOARD_ACTIVITY_CLICKED = 'dashboard-activity-clicked',
  DASHBOARD_ACTIVITY_VIDEO_CLICKED = 'dashboard-activity-video-clicked',
  DASHBOARD_ONLINE_WORKSHEET_CLICKED = 'dashboard-online-worksheet-clicked',
  DASHBOARD_ONLINE_WORKSHEET_COMPLETED = 'dashboard-online-worksheet-completed',
  DASHBOARD_WORKSHEET_DOWNLOAD = 'file_download',
  DASHBOARD_WORKSHEET_UPLOAD = 'dashboard-offline-worksheet-upload',
  // MUSIC
  MUSIC_ITEM_CLICKED = 'music-item-clicked',
  MUSIC_ITEM_ADD_TO_FAVORITES = 'music-item-add-to-favorites',
  // LIBRARY
  LIBRARY_ADD_VIDEO_TO_FAVORITES = 'library-add-video-to-favorites',
  // BITHDAY
  SHOW_BIRTHDAY_MODAL = 'show-birthday-modal',
}
